/* YESSKIN · Páginas de producto "pd-*" — animaciones e interacciones extra (sin dependencias).
   Se apoya en uv-landing.js (galería, packs, carrito, barra fija, aparición al hacer scroll). */
(function () {
  'use strict';
  if (window.__pdLanding) return;
  window.__pdLanding = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- números: "$2.490" <-> 2490 ---------- */
  function parseMoney(t) {
    var m = String(t || '').match(/^(\D*)([\d.,]+)(.*)$/);
    if (!m) return null;
    var raw = m[2];
    if (/,\d{1,2}$/.test(raw)) return null; // con decimales: no se anima
    return { pre: m[1], num: parseInt(raw.replace(/[.,]/g, ''), 10), post: m[3] };
  }
  function fmt(n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function roll(el, fromText, toText, dur) {
    if (!el) return;
    var a = parseMoney(fromText), b = parseMoney(toText);
    if (reduce || !a || !b || a.num === b.num) { el.textContent = toText; return; }
    var t0 = null; dur = dur || 520;
    function step(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = b.pre + fmt(a.num + (b.num - a.num) * e) + b.post;
      if (p < 1) requestAnimationFrame(step); else el.textContent = toText;
    }
    requestAnimationFrame(step);
  }

  /* ---------- packs ---------- */
  function initMain(root) {
    if (root.__pd) return; root.__pd = true;
    var offers = $$('[data-uv-offer]', root);
    var priceEl = $('[data-uv-atc-price]', root);
    var amtEl = $('[data-uv-save-amount]', root);
    var lastPrice = priceEl ? priceEl.textContent : '';
    var lastSave = amtEl ? amtEl.textContent : '';

    function sync() {
      offers.forEach(function (o) {
        var more = $('.pd-offer__more', o);
        if (more) more.setAttribute('aria-hidden', o.classList.contains('is-selected') ? 'false' : 'true');
      });
    }
    offers.forEach(function (o) {
      function fx() {
        // uv-landing.js ya actualizó el precio; acá lo hacemos "rodar" desde el valor anterior
        setTimeout(function () {
          sync();
          if (priceEl) { var np = o.getAttribute('data-price') || priceEl.textContent; roll(priceEl, lastPrice, np); lastPrice = np; }
          if (amtEl) { var ns = o.getAttribute('data-save') || ''; if (ns) roll(amtEl, lastSave || ns, ns, 700); lastSave = ns; }
        }, 0);
        if (reduce) return;
        o.classList.remove('is-burst', 'is-bump'); void o.offsetWidth; o.classList.add('is-burst', 'is-bump');
        clearTimeout(o.__pdT); o.__pdT = setTimeout(function () { o.classList.remove('is-burst', 'is-bump'); }, 700);
      }
      o.addEventListener('click', fx);
      o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') fx(); });
    });
    sync();
  }

  /* al tocar un botón "ir a los packs", el pack elegido hace un pequeño rebote al llegar */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-uv-scroll-buy]');
    if (!a || reduce) return;
    setTimeout(function () {
      var sel = $('[data-pd-main] .pd-offer.is-selected');
      if (sel) { sel.classList.remove('is-bump'); void sel.offsetWidth; sel.classList.add('is-bump'); setTimeout(function () { sel.classList.remove('is-bump'); }, 600); }
    }, 750);
  });

  /* ---------- fecha estimada de llegada ---------- */
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  function nextBiz(d) { var x = new Date(d.getTime()); do { x.setDate(x.getDate() + 1); } while (x.getDay() === 0 || x.getDay() === 6); return x; }
  function initShip(el) {
    if (el.__pd) return; el.__pd = true;
    var now = new Date(), cut = parseInt(el.getAttribute('data-cutoff'), 10) || 14;
    var biz = now.getDay() !== 0 && now.getDay() !== 6;
    var today = biz && now.getHours() < cut;
    var ship = today ? now : nextBiz(now);
    var arrive = nextBiz(ship);
    var tomorrow = new Date(now.getTime()); tomorrow.setDate(now.getDate() + 1);
    var label = (arrive.toDateString() === tomorrow.toDateString() ? 'mañana ' : 'el ') + DAYS[arrive.getDay()] + ' ' + arrive.getDate() + '/' + (arrive.getMonth() + 1);
    var tpl = today ? el.getAttribute('data-tpl') : (el.getAttribute('data-tpl-late') || el.getAttribute('data-tpl'));
    var span = $('span', el); if (!span || !tpl) return;
    var safe = document.createElement('div'); safe.textContent = tpl.replace('[hora]', cut);
    span.innerHTML = safe.innerHTML.replace('[fecha]', '<b>' + label + '</b>');
  }

  /* ---------- contadores con separador de miles ---------- */
  var countIO = hasIO ? new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      if (!e.isIntersecting) return;
      countIO.unobserve(e.target);
      var el = e.target, to = parseFloat(String(el.getAttribute('data-pd-count')).replace(/[^\d.]/g, '')) || 0, t0 = null, dur = 1600;
      if (reduce) { el.textContent = fmt(to); return; }
      function step(t) { if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur), k = 1 - Math.pow(1 - p, 3); el.textContent = fmt(to * k); if (p < 1) requestAnimationFrame(step); }
      el.textContent = '0'; requestAnimationFrame(step);
    });
  }, { threshold: 0.6 }) : null;
  function initCount(el) {
    if (el.__pd) return; el.__pd = true;
    var raw = el.getAttribute('data-pd-count');
    if (!/^\s*[\d.]+\s*$/.test(raw || '')) return;
    if (countIO) countIO.observe(el); else el.textContent = fmt(parseFloat(raw));
  }

  /* ---------- antes / después ---------- */
  var baIO = hasIO ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { if (e.isIntersecting && e.target.__pdHint) { baIO.unobserve(e.target); e.target.__pdHint(); } });
  }, { threshold: 0.6 }) : null;
  function initBA(el) {
    if (el.__pd) return; el.__pd = true;
    var range = $('[data-pd-ba-range]', el), touched = false, dragging = false, sx = 0, sy = 0, decided = false;
    function set(p) { p = Math.max(2, Math.min(98, p)); el.style.setProperty('--pos', p + '%'); if (range) range.value = Math.round(p); }
    function fromX(x) { var r = el.getBoundingClientRect(); set(((x - r.left) / r.width) * 100); }
    el.addEventListener('pointerdown', function (e) { touched = true; dragging = true; decided = e.pointerType === 'mouse'; sx = e.clientX; sy = e.clientY; if (decided) { fromX(e.clientX); try { el.setPointerCapture(e.pointerId); } catch (x) {} } });
    el.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      if (!decided) {
        var dx = Math.abs(e.clientX - sx), dy = Math.abs(e.clientY - sy);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) { dragging = false; return; }
        decided = true; try { el.setPointerCapture(e.pointerId); } catch (x) {}
      }
      e.preventDefault(); fromX(e.clientX);
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) { el.addEventListener(ev, function () { dragging = false; }); });
    el.addEventListener('click', function (e) { if (!decided) { touched = true; fromX(e.clientX); } });
    if (range) range.addEventListener('input', function () { touched = true; set(parseFloat(range.value)); });
    el.__pdHint = function () {
      if (reduce || touched) return;
      el.classList.add('is-hint');
      var keys = [[0, 50], [700, 22], [1500, 78], [2200, 50]], t0 = null;
      function step(t) {
        if (touched) return;
        if (!t0) t0 = t;
        var dt = t - t0, i = 0;
        while (i < keys.length - 1 && dt > keys[i + 1][0]) i++;
        if (i >= keys.length - 1) { set(50); return; }
        var a = keys[i], b = keys[i + 1], p = (dt - a[0]) / (b[0] - a[0]), k = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        set(a[1] + (b[1] - a[1]) * k);
        requestAnimationFrame(step);
      }
      setTimeout(function () { requestAnimationFrame(step); }, 350);
    };
    if (baIO) baIO.observe(el);
  }

  /* ---------- pasos: línea que se llena con el scroll ---------- */
  var stepsList = [], ticking = false;
  function paintSteps() {
    ticking = false;
    var vh = window.innerHeight;
    stepsList.forEach(function (w) {
      var line = $('.pd-steps__line', w); if (!line) return;
      var r = line.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var p = Math.max(0, Math.min(1, (vh * 0.62 - r.top) / (r.height || 1)));
      w.style.setProperty('--p', p.toFixed(3));
      var fillY = r.top + p * r.height;
      $$('[data-pd-step]', w).forEach(function (s) {
        var n = $('.pd-step__num', s); if (!n) return;
        var nr = n.getBoundingClientRect();
        s.classList.toggle('is-done', fillY >= nr.top + nr.height / 2 - 2);
      });
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(paintSteps); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  function initSteps(w) { if (w.__pd) return; w.__pd = true; stepsList.push(w); onScroll(); }

  /* ---------- villanos: se tachan al aparecer ---------- */
  var stampIO = hasIO ? new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      if (!e.isIntersecting) return;
      stampIO.unobserve(e.target);
      var el = e.target; setTimeout(function () { el.classList.add('is-stamped'); }, 380);
    });
  }, { threshold: 0.55 }) : null;
  function initStamp(el) { if (el.__pd) return; el.__pd = true; if (stampIO && !reduce) stampIO.observe(el); else el.classList.add('is-stamped'); }

  /* ---------- zonas: alternar antes/después solo mientras se ve ---------- */
  var swapIO = hasIO ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { e.target.classList.toggle('is-run', e.isIntersecting); });
  }, { threshold: 0.3 }) : null;
  function initSwap(el) { if (el.__pd) return; el.__pd = true; if (swapIO && !reduce) swapIO.observe(el); }

  /* ---------- init ---------- */
  function scan(root) {
    root = root || document;
    $$('[data-pd-main]', root).forEach(initMain);
    $$('[data-pd-ship]', root).forEach(initShip);
    $$('[data-pd-count]', root).forEach(initCount);
    $$('[data-pd-ba]', root).forEach(initBA);
    $$('[data-pd-steps]', root).forEach(initSteps);
    $$('[data-pd-stamp]', root).forEach(initStamp);
    $$('[data-pd-swap]', root).forEach(initSwap);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
